import { createContext, useContext, useState, ReactNode } from 'react'

interface SidebarContextType {
  sidebarVisible: boolean
  setSidebarVisible: (visible: boolean) => void
  hideSidebar: () => void
  showSidebar: () => void
  toggleSidebar: () => void
  sidebarCollapsed: boolean
  setSidebarCollapsed: (collapsed: boolean) => void
  toggleCollapse: () => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export function SidebarProvider({ children }: { children: ReactNode }) {
  const SIDEBAR_VISIBLE_KEY = 'clnicl_sidebar_visible'
  const SIDEBAR_COLLAPSED_KEY = 'clnicl_sidebar_collapsed'
  
  const [sidebarVisible, setSidebarVisibleState] = useState(() => {
    const saved = localStorage.getItem(SIDEBAR_VISIBLE_KEY)
    return saved !== null ? saved === 'true' : true
  })

  const [sidebarCollapsed, setSidebarCollapsedState] = useState(() => {
    const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY)
    return saved !== null ? saved === 'true' : false
  })

  const setSidebarVisible = (visible: boolean) => {
    setSidebarVisibleState(visible)
    localStorage.setItem(SIDEBAR_VISIBLE_KEY, String(visible))
  }

  const setSidebarCollapsed = (collapsed: boolean) => {
    setSidebarCollapsedState(collapsed)
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed))
  }

  const hideSidebar = () => setSidebarVisible(false)
  const showSidebar = () => setSidebarVisible(true)
  const toggleSidebar = () => setSidebarVisible(!sidebarVisible)
  const toggleCollapse = () => setSidebarCollapsed(!sidebarCollapsed)

  return (
    <SidebarContext.Provider
      value={{
        sidebarVisible,
        setSidebarVisible,
        hideSidebar,
        showSidebar,
        toggleSidebar,
        sidebarCollapsed,
        setSidebarCollapsed,
        toggleCollapse,
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

export function useSidebar() {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}

































